import { Component, Input, OnInit, Output,EventEmitter,SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ArticoliDropdown, CalculateFruitionDateRequest, Campaign3Campaign, Campaign3Info, Campaign3MessageInstance, MessageInstanceObject, ProductItemBarcodeResponse, ProductItemComplete } from 'app/views/campaign-3/models/campaign-3.model';
import { FruizioneDropdown, GenerazioneDropdown } from 'app/views/campaign-3/models/campaign-3-planning.model';
import { Campaign3TestService } from 'app/views/campaign-3/services/campaign3testservice';
import { PreferredCoupon } from 'app/views/campaign-3/models/campaign-3-info-base.model';
import { FormFields } from 'app/views/campaign-3/components/form-fields/form-fields.component';
import { Campaign3KontableComponent } from 'app/views/campaign-3/components/campaign-3-kontable/campaign-3-kontable.component';
import { Campaign3Service } from 'app/views/campaign-3/services/campaign3.service';


@Component({
  selector: 'app-create-message-from-existing',
  templateUrl: './create-message-from-existing.component.html',
  styleUrls: ['./create-message-from-existing.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class Campaign3CreateExistingMessage implements OnInit {


   @Input() comboInizioFruizione: Array<GenerazioneDropdown>;
  @Input() comboFineFruizione: Array<FruizioneDropdown>; 
  //@Input() comboGiornoSettimanaInizioFruizione: Array<{day: number,name: string}>
  //@Input() comboGiornoSettimanaFineFruizione: Array<{day: number,name: string}>
  @Input() campaignInfoTo: Campaign3Info = null;
  @Input() dateFormat: string = "dd/MM/yyyy";

  @ViewChild('new_name') new_name: FormFields;
  @ViewChild('azione') azione: FormFields;
  @ViewChild('existing_data_inizio_emissione') existing_data_inizio_emissione: FormFields;
  @ViewChild('existing_data_fine_emissione') existing_data_fine_emissione: FormFields;
/*   @ViewChild('existing_data_inizio_fruizione') existing_data_inizio_fruizione: FormFields;
  @ViewChild('existing_data_fine_fruizione') existing_data_fine_fruizione: FormFields; */
/*   @ViewChild('existing_modalita_inizio_fruizione') existing_modalita_inizio_fruizione: FormFields;
  @ViewChild('existing_modalita_fine_fruizione') existing_modalita_fine_fruizione: FormFields;
  @ViewChild('existing_offset_inizio_fruizione') existing_offset_inizio_fruizione: FormFields;
  @ViewChild('existing_data_inizio_fruizione_fissa') existing_data_inizio_fruizione_fissa: FormFields; */
  @ViewChild('existing_giorno_settimana_inizio') existing_giorno_settimana_inizio: FormFields;
  @ViewChild('existing_offset_fine_fruizione') existing_offset_fine_fruizione: FormFields;
  @ViewChild('existing_data_fine_fruizione_fissa') existing_data_fine_fruizione_fissa: FormFields;
  @ViewChild('existing_giorno_settimana_fine') existing_giorno_settimana_fine: FormFields;

  @ViewChild('couponTable') kontableComponent: Campaign3KontableComponent;
  
  //articolo barcode
  @ViewChild('existingArticoloCoupon') existingArticoloCoupon: FormFields;
  @ViewChild('existingSoloBarcode') existingSoloBarcode: FormFields;
  @ViewChild('existingSoloBarcodeText') existingSoloBarcodeText: FormFields;
  @ViewChild('existingComboBarcodes') existingComboBarcodesComponent: FormFields;

  @Output() messageInstanceSelected: EventEmitter<boolean> = new EventEmitter<boolean>();

  comboBarcodes: Array<{id: string, barcode: string}>;
  
  campaignInfoFrom: Campaign3Info;
  //messageInstance: Campaign3MessageInstance;
  messageInstanceComplete: MessageInstanceObject;

  choiceCode: string = "";
  paginationType: number = Campaign3KontableComponent.ClientPagination;

  fieldModel = {
    new_name: null,
    campaign: null,
    action: null,
    data_inizio_emissione: null,
    data_fine_emissione: null,
   /*  data_inizio_fruizione:null,
    data_fine_fruizione: null,
    offset_inizio_fruizione: null,
    offset_fine_fruizione: null,
    data_inizio_fruizione_fissa: null,
    data_fine_fruizione_fissa: null,
    modalita_inizio_fruizione: null,
    modalita_fine_fruizione: null, */
    giorno_settimana_inizio: null,
    giorno_settimana_fine: null,
    articoloCoupon: {
      articolo: null,
      barcode: null
    },
    barcodeManualCoupon: null
  }

  show = {
    comboCampaign: false,
   /*  offsetFineFruizione: false,
    fissaFineFruizione: false, */
    giorno_settimana_fine: false,
 /*    offsetInizioFruizione: false,
    fissaInizioFruizione: false, */
    giorno_settimana_inizio: false,
    comboArticoloCoupon: false,
    modalProductList: false,
    switchAsEmission: true,
    switchVariabili: false,
    variablesInfo: false,
    duplicateForm: false,
    tablePreferred: false
  }

  switch = {
    asCampaign: false,
    fissaInizioFruizione: false,
    variable: false,
    asEmission: false,
    soloBarcode: false
  }

  comboCampagne: Array<Campaign3Campaign> = [];

  comboAzioni: Array<Campaign3MessageInstance> = [];


  valid: boolean = true;

  constructor(public srvCampaign: Campaign3Service,
    public testService: Campaign3TestService){

  }
  ngOnInit(): void {
    
  }
  setCampaignInfo(campaignInfo: Campaign3Campaign){
    this.campaignInfoFrom = new Campaign3Info();
    this.campaignInfoFrom.id = campaignInfo.id;
    this.campaignInfoFrom.dateStart = this.srvCampaign.getDateFromDateStringDB(campaignInfo.start_date);
    this.campaignInfoFrom.dateEnd = this.srvCampaign.getDateFromDateStringDB(campaignInfo.end_date);
    this.campaignInfoFrom.name = campaignInfo.name;
    this.campaignInfoFrom.description = campaignInfo.description;
  }
  loadCampaign(id: number){
    //se passato l'id carica le informazioni della campagna (caso preferiti)
    var self = this;
    this.srvCampaign.getCampaign(id).subscribe(res=>{
      if(res){
       
     //   self.setCampaignInfo(res[0]);
        self.onChangeCampaignSelected(res[0]);
      }
    });
  }
  loadMessageInstance(id: number){
    var self = this;
    this.srvCampaign.getMessageInstanceComplete(id).subscribe(res=>{
      if(res){
        self.messageInstanceComplete = res.messageInstance[0];
    
        self.messageInstanceSelected.emit(true);

        if(self.messageInstanceComplete.flgRolling == "1"){
          self.show.switchAsEmission = false;
          self.show.variablesInfo = true;
        }
        else{
          self.show.switchAsEmission = true;
          self.show.switchVariabili = false;
        }
        self.show.duplicateForm = true;
        self.messageInstanceSelected.emit(true);
      }
    });
  }
  onClickSearchArticolo(){
    if(!this.switch.soloBarcode){
      this.fieldModel.articoloCoupon.articolo = null;
      this.fieldModel.articoloCoupon.barcode = null;
      this.fieldModel.barcodeManualCoupon = null;
      this.show.modalProductList = true;
    }
  }
  onChangedFilterArticolo(searchValue){
      this.comboBarcodes = [];
      this.fieldModel.articoloCoupon.barcode = null;
      this.existingComboBarcodesComponent.fieldModel = null;
      this.existingComboBarcodesComponent.options = [];
  }
  onChangeSoloBarcode(value: boolean){
    this.switch.soloBarcode = value;
    var self = this;

    setTimeout(function(){
      if(value == true){
        if(self.existingArticoloCoupon){
          self.existingArticoloCoupon.disabled = true;
          self.existingArticoloCoupon.required = false;
        }
        if(self.existingSoloBarcodeText){
          self.existingSoloBarcodeText.required = true;
        }
        if(self.existingComboBarcodesComponent){
          self.existingComboBarcodesComponent.required = false;
        }
      }
      else{
        if(self.existingArticoloCoupon){
          self.existingArticoloCoupon.disabled = false;
          self.existingArticoloCoupon.required = true;
          if(self.existingSoloBarcodeText){
            self.existingSoloBarcodeText.required = false;
          }
          if(self.existingComboBarcodesComponent){
            self.existingComboBarcodesComponent.required = true;
          }
        }
      }
    },100);
    
    this.fieldModel.articoloCoupon.articolo = null;
    this.fieldModel.articoloCoupon.barcode = null;
    this.fieldModel.barcodeManualCoupon = null;
  }
  onPreferredSelected(mi: PreferredCoupon){
    this.loadCampaign(mi.campaign_id);
    this.loadMessageInstance(mi.id);
    this.show.tablePreferred = false;
  }
  onChangeArticoloCoupon(articolo: ProductItemComplete){

    this.comboBarcodes = [];
    if(articolo && articolo.barcodes && articolo.barcodes.length>0){
      for(let barcode of articolo.barcodes){
        this.comboBarcodes.push({id: barcode, barcode: barcode});
      }
    }
   
    this.existingComboBarcodesComponent.fieldModel = null;
    this.existingComboBarcodesComponent.options = this.comboBarcodes;

    if(this.comboBarcodes.length==1){
      this.existingComboBarcodesComponent.fieldModel = this.comboBarcodes[0];;
      this.fieldModel.articoloCoupon.barcode = this.comboBarcodes[0];
    }
    else{
      this.fieldModel.articoloCoupon.barcode = null;
    }
  }
  onProductSelected(articolo: any){
    if(articolo){
      this.existingArticoloCoupon.options = [articolo];
      this.fieldModel.articoloCoupon.articolo = articolo;

      this.comboBarcodes = [];
      if(articolo && articolo.barcode){
        this.comboBarcodes.push({id: articolo.barcode, barcode: articolo.barcode});
      }
     
      this.existingComboBarcodesComponent.options = this.comboBarcodes;
      this.fieldModel.articoloCoupon.barcode = this.comboBarcodes[0];
    
      this.existingComboBarcodesComponent.fieldModel = {id: articolo.barcode, barcode: articolo.barcode};
  
      this.show.modalProductList = false;
    }
  }
  onClickPreferred(){
    this.show.duplicateForm = false;
    this.choiceCode = "PREFERRED";
    this.fieldModel.campaign = null;
    this.messageInstanceComplete = null;
    this.resetVariableFieldsInizio();
    this.resetVariableFieldsFine();
    this.show.tablePreferred = true;
    this.show.comboCampaign = false;
    this.messageInstanceSelected.emit(false);
  }
  onClickOtherAction(){
    this.show.duplicateForm = false;
    this.fieldModel.campaign = null;
    this.messageInstanceComplete = null;
    this.resetVariableFieldsInizio();
    this.resetVariableFieldsFine();
    this.show.tablePreferred = false;
    this.show.comboCampaign = false;

    this.choiceCode = "OTHER";
    var self = this;
    
    //se non passato l'id carica tutte le campagne (caso scelta campagna)
     this.srvCampaign.getAllCampaignsNoLimit().subscribe(res=>{
      if(res && res.length>0){
        self.comboCampagne = res;
        self.show.comboCampaign = true;
      }
    });

    this.messageInstanceSelected.emit(false);
  }
  onChangeCampaignSelected(campaign: Campaign3Campaign){
    this.setCampaignInfo(campaign);
    this.fieldModel.action = null;
    this.comboAzioni =  [];

    var self = this;
      if(campaign && campaign.id){
        this.srvCampaign.getMessageInstanceFromCampaign(campaign.id).subscribe(res => {

          // Filtra i risultati dove action_type è "Coupon "
          const filteredRes = res.filter(item => item.action_type === "Messaggio");

          if(filteredRes && filteredRes.length > 0){
            self.comboAzioni = filteredRes;
            self.azione.options = filteredRes;
          }
        });
    }
  }
  onMessageInstanceSelected(messageInstance: Campaign3MessageInstance){

   // this.messageInstance = messageInstance ? messageInstance : null;
    if(messageInstance){
      //posso farlo parallelamente perchè mi serve solo per avere dei dati descrittivi, non devo farci operazioni, non devo per forza aspettare
      this.loadMessageInstance(messageInstance.id);
    }
  }
  resetFruizione(){
   /*  this.fieldModel.data_inizio_fruizione = null;
    this.fieldModel.data_fine_fruizione = null;
    this.fieldModel.offset_inizio_fruizione = null;
    this.fieldModel.offset_fine_fruizione = null;
    this.fieldModel.data_inizio_fruizione_fissa = null;
    this.fieldModel.data_fine_fruizione_fissa = null;
    this.fieldModel.modalita_inizio_fruizione = null;
    this.fieldModel.modalita_fine_fruizione = null; */
    this.fieldModel.giorno_settimana_inizio = null;
    this.fieldModel.giorno_settimana_fine = null;
  }
  onChangeAsCampaign(){
  
    /*** si ritorna allo stato iniziale */
    this.resetFruizione();
    this.switch.variable = false;
    this.switch.asEmission = false;
    var self = this;


    if(this.switch.asCampaign == true){
      setTimeout(function(){
        self.fieldModel.data_inizio_emissione = self.campaignInfoTo.dateStart;
        self.fieldModel.data_fine_emissione = self.campaignInfoTo.dateEnd;
  
     /*    //la data minima per l'inizio e la fine fruizione è uguale alla data di inizio emissione, non prima
        if(self.existing_data_inizio_fruizione) self.existing_data_inizio_fruizione.minDate = self.campaignInfoTo.dateStart;
        if(self.existing_data_fine_fruizione) self.existing_data_fine_fruizione.minDate = self.campaignInfoTo.dateStart; */
  
      },100);
     
    }
    else{
      setTimeout(function(){
        self.fieldModel.data_inizio_emissione = null;
        self.fieldModel.data_fine_emissione = null;
      },100);
    }
  }
  onChangeAsEmission(){
    this.switch.variable = false;
    var self = this;
    setTimeout(function(){

      self.resetFruizione();
    
     /*  if(self.switch.asEmission == true){
      
        self.existing_data_inizio_fruizione.minDate = self.fieldModel.data_inizio_emissione ? self.fieldModel.data_inizio_emissione :  self.campaignInfoFrom.dateStart;
        self.existing_data_fine_fruizione.minDate = self.fieldModel.data_inizio_emissione ? self.fieldModel.data_inizio_emissione :  self.campaignInfoFrom.dateStart;
        
        self.fieldModel.data_inizio_fruizione = self.fieldModel.data_inizio_emissione;
        self.fieldModel.data_fine_fruizione = self.fieldModel.data_fine_emissione;
  
        
      }
      else{
       
        self.existing_data_inizio_fruizione.minDate = self.campaignInfoFrom.dateStart;
        self.existing_data_fine_fruizione.minDate = self.campaignInfoFrom.dateStart;
 
      } */
    },100);
 
    
  }
  onChangeVariable(){
    var self = this;
    setTimeout(function(){
     /*  self.fieldModel.modalita_inizio_fruizione = null;
      self.fieldModel.modalita_fine_fruizione = null; */
      self.resetVariableFieldsInizio();
      self.resetVariableFieldsFine();
      self.switch.asEmission = false;
      //scatta quando cambia l'input switch con date di emissione
 /*      if(self.switch.variable == true){
        self.existing_modalita_inizio_fruizione.required = true;
        self.existing_modalita_fine_fruizione.required = true;
      }
      else{     
        self.existing_data_inizio_fruizione.required = true;
        self.existing_data_fine_fruizione.required = true;
      } */
    },100);

  }
 /*  onChangeInizioEmissione(date: Date){
    this.existing_data_inizio_fruizione.minDate = date ? date : this.campaignInfoFrom.dateStart;
    this.existing_data_fine_fruizione.minDate = date ? date : this.campaignInfoFrom.dateStart;
  }
  onChangeFineEmissione(date: Date){
    if(this.switch.asEmission == true){
      this.fieldModel.data_fine_fruizione = date;
    }
  } */
  /* onChangeInizioFruizione(date: Date){
    if(this.existing_data_fine_fruizione){
      this.existing_data_fine_fruizione.minDate = date ? date : this.campaignInfoFrom.dateStart;
    }
   
  } */
  onChangeInizioFruizioneFissa(){

  }
  resetVariableFieldsInizio(){
/*     if(this.existing_offset_inizio_fruizione)this.existing_offset_inizio_fruizione.required = false;   
    if(this.existing_data_inizio_fruizione_fissa) this.existing_data_inizio_fruizione_fissa.required = false;  */
    if(this.existing_giorno_settimana_inizio) this.existing_giorno_settimana_inizio.required = false;
   /*  this.fieldModel.data_inizio_fruizione_fissa = null;  
    this.fieldModel.offset_inizio_fruizione = null; */
    this.fieldModel.giorno_settimana_inizio = null;
  /*   this.show.offsetInizioFruizione = false;
    this.show.fissaInizioFruizione = false; */
    this.show.giorno_settimana_inizio = false;
  }
  resetVariableFieldsFine(){   
    if(this.existing_offset_fine_fruizione) this.existing_offset_fine_fruizione.required = false;
    if(this.existing_data_fine_fruizione_fissa) this.existing_data_fine_fruizione_fissa.required = false;
    if(this.existing_giorno_settimana_fine) this.existing_giorno_settimana_fine.required = false;

  /*   this.fieldModel.data_fine_fruizione_fissa = null;
    this.fieldModel.offset_fine_fruizione = null; */
    this.fieldModel.giorno_settimana_fine = null;

   /*  this.show.offsetFineFruizione = false;
    this.show.fissaFineFruizione = false; */
    this.show.giorno_settimana_fine = false;

  }
  onChangeModalitaInizioFruizione(dropdownFruizione: GenerazioneDropdown,firstEditLoad: boolean = false){
    var self = this;
    if(!firstEditLoad){
      this.resetVariableFieldsInizio();
    }
    else {
  /*     setTimeout(function(){
        self.existing_modalita_inizio_fruizione.required = true;
      },100); */
    }

    if(dropdownFruizione.code == "START.VAL.CPN.DAY.OFFSET"){
      //dayOfGenerationOffset
      //giorno di generazione + offset
   /*    this.show.offsetInizioFruizione = true;
      setTimeout(function(){
        self.existing_offset_inizio_fruizione.required = true;
      },100); */
    }
    else if(dropdownFruizione.code == "START.VAL.CPN.DAY"){
      //dayOfGeneration
      //giorno di generazione

    }
    else if(dropdownFruizione.code == "START.VAL.CPN.DATE"){
      //fixed date
      //data fissa
      //l'utente dovrà scegliere le due date
     /*  this.show.fissaInizioFruizione = true;
      setTimeout(function(){
        self.existing_data_inizio_fruizione_fissa.required = true;
      },100); */
    }
    else if(dropdownFruizione.code == "START.VAL.CPN.LAST.MONTH.DAY.GEN"){
      //lastDayOfMonthGeneration
      //ultimo giorno del mese successivo alla generazione
   
    }
    else if(dropdownFruizione.code == "START.VAL.CPN.FIRST.DAY.GEN"){
      //firstDayOfMonthFollowingGeneration
      //primo giorno del mese successivo alla generazione
     
    }
    else if(dropdownFruizione.code == "START.VAL.CPN.NEXT.DAY.GEN"){
      //dayofWeekFollowingGeneration
      //giorno settimana successiva al giorno di generazione
     this.show.giorno_settimana_inizio = true;
     setTimeout(function(){
      self.existing_giorno_settimana_inizio.required = true;
    },100);
    }
  }
  
  onChangeModalitaFineFruizione(dropdownFruizione: GenerazioneDropdown,firstEditLoad: boolean = false){

    var self = this;

    if(!firstEditLoad){
      this.resetVariableFieldsFine();
    }
    /* setTimeout(function(){
      self.existing_modalita_fine_fruizione.required = true;
    },100); */
    

    if(dropdownFruizione.code == "END.VAL.CPN.DAY.OFFSET"){
      //dayOfGenerationOffset
      //giorno di generazione + offset
/*       this.show.offsetFineFruizione = true;
 */      setTimeout(function(){
        self.existing_offset_fine_fruizione.required = true;
      },100);
    }
    else if(dropdownFruizione.code == "END.VAL.CPN.DAY"){
      //dayOfGeneration
      //giorno di generazione
    }
    else if(dropdownFruizione.code == "END.VAL.CPN.DATE"){
      //fixed date
      //data fissa
      //l'utente dovrà scegliere le due date
/*       this.show.fissaFineFruizione = true;
 */      setTimeout(function(){
        self.existing_data_fine_fruizione_fissa.required = true;
      },100);
    }
    else if(dropdownFruizione.code == "END.VAL.CPN.LAST.MONTH.DAY.GEN"){
      //lastDayOfMonthGeneration
      //ultimo giorno del mese successivo alla generazione
     
    }
    else if(dropdownFruizione.code == "END.VAL.CPN.FIRST.DAY.GEN"){
      //firstDayOfMonthFollowingGeneration
      //primo giorno del mese successivo alla generazione
    
    }
    else if(dropdownFruizione.code == "END.VAL.CPN.NEXT.DAY.GEN"){
      //dayofWeekFollowingGeneration
      //settimana successiva al giorno di generazione
      this.show.giorno_settimana_fine = true;
      setTimeout(function(){
        self.existing_giorno_settimana_fine.required = true;
      },100);
    }
  }
  onClickAnnulla_ModalArticoli(){
   
    this.show.modalProductList = false;
  }

  //cancella dai preferiti
  onDeleteFromFavourite(row:MessageInstanceObject){
  
    this.srvCampaign.deleteActionFromFavourites(row).subscribe(res => {
      this.kontableComponent.refresh();
    }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/views/campaing-3-message/message-3-info-base/create-message-from-existing/create-message-from-existing.component.ts